(() => {
  const syncAnnouncementHeaderOffset = () => {
    const announcementSection = document.querySelector(
      '.announcement-bar-section'
    );

    const announcementBar = announcementSection?.querySelector(
      '.palo-announcement-bar'
    );

    const isVisible =
      announcementSection &&
      announcementBar &&
      !announcementSection.hidden &&
      !announcementBar.hidden &&
      getComputedStyle(announcementSection).display !== 'none' &&
      getComputedStyle(announcementBar).display !== 'none';

    const height = isVisible
      ? Math.ceil(announcementBar.getBoundingClientRect().height)
      : 0;

    document.documentElement.style.setProperty(
      '--palo-announcement-offset',
      `${height}px`
    );
  };

  const requestOffsetSync = () => {
    window.requestAnimationFrame(syncAnnouncementHeaderOffset);
  };

  const initAnnouncementBars = (root = document) => {
    root.querySelectorAll('[data-palo-announcement]').forEach((bar) => {
      if (bar.dataset.paloInitialized === 'true') return;
      bar.dataset.paloInitialized = 'true';

      const closeButton = bar.querySelector(
        '[data-palo-announcement-close]'
      );

      if (!closeButton) return;

      const storageKey =
        `palo-announcement-dismissed-${bar.dataset.sectionId || 'global'}`;

      const rememberDismissal =
        bar.dataset.rememberDismissal === 'true';

      try {
        if (
          rememberDismissal &&
          window.localStorage.getItem(storageKey) === 'true'
        ) {
          bar.hidden = true;
          requestOffsetSync();
          return;
        }
      } catch (error) {
        // Storage may be unavailable in privacy-restricted browsers.
      }

      closeButton.addEventListener('click', () => {
        bar.hidden = true;

        if (rememberDismissal) {
          try {
            window.localStorage.setItem(storageKey, 'true');
          } catch (error) {
            // Ignore storage failures.
          }
        }

        requestOffsetSync();
        window.dispatchEvent(new Event('resize'));
      });
    });
  };

  const initHoverMenus = (root = document) => {
    root
      .querySelectorAll(
        '[data-palo-header][data-open-on-hover="true"]'
      )
      .forEach((header) => {
        if (header.dataset.paloHoverInitialized === 'true') return;
        header.dataset.paloHoverInitialized = 'true';

        const desktopQuery = window.matchMedia('(min-width: 990px)');
        const detailsElements = Array.from(
          header.querySelectorAll('header-menu > details')
        );

        let closeTimer;

        const closeDetails = (details) => {
          details.removeAttribute('open');

          const summary = details.querySelector(':scope > summary');
          summary?.setAttribute('aria-expanded', 'false');
        };

        const openDetails = (details) => {
          if (!desktopQuery.matches) return;

          window.clearTimeout(closeTimer);

          detailsElements.forEach((item) => {
            if (item !== details) closeDetails(item);
          });

          details.setAttribute('open', '');

          const summary = details.querySelector(':scope > summary');
          summary?.setAttribute('aria-expanded', 'true');
        };

        detailsElements.forEach((details) => {
          details.addEventListener(
            'mouseenter',
            () => openDetails(details)
          );

          details.addEventListener('mouseleave', () => {
            closeTimer = window.setTimeout(
              () => closeDetails(details),
              140
            );
          });

          details.addEventListener(
            'focusin',
            () => openDetails(details)
          );

          details.addEventListener('focusout', (event) => {
            if (!details.contains(event.relatedTarget)) {
              closeDetails(details);
            }
          });
        });
      });
  };

  const init = (root = document) => {
    initAnnouncementBars(root);
    initHoverMenus(root);
    requestOffsetSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init()
    );
  } else {
    init();
  }

  window.addEventListener('load', requestOffsetSync);
  window.addEventListener('resize', requestOffsetSync, {
    passive: true
  });

  document.addEventListener(
    'shopify:section:load',
    (event) => init(event.target)
  );

  document.addEventListener(
    'shopify:section:reorder',
    requestOffsetSync
  );

  document.addEventListener(
    'shopify:section:select',
    requestOffsetSync
  );
})();
